import React from 'react';
import style from './index.scss';
import HeaderBanner from './../../common/HeaderBanner';

export const TabTitles = () => (
    <div className={style.tabTitles}>
        <Tab />
        <Tab />
    </div>
);

export const CompRow = () => (
    <div className={style.compRow}>
        <Tab />
        <Tab />
        <Tab />
    </div>
);

export const CompTable = () => (
    <div>
        <CompRow />
        <CompRow />
        <CompRow />
        <CompRow />
    </div>
);

export const Tab = () => (
    <div className={style.tabContainer}>
        <div className={style.textShape} />
    </div>
);

export const JoinButton = () => (
    <div className={style.joinButton}>
        <div className={style.button} />
    </div>
);

export const FakeImage = () => (
    <div className={style.fakeImage}>
    </div>
);

export const InfoSection = () => (
    <div className={style.InfoSection}>
        <Tab />
        <Tab />
    </div>
);

export const AdditionalInfo = () => (
    <div>
        <div className={style.spacing} />
        <div className={style.AdditionalInfo}>
            <InfoSection />
            <InfoSection />
        </div>
        <div className={style.spacing} />
        <div className={style.AdditionalInfo}>
            <InfoSection />
            <InfoSection />
        </div>
    </div>
);

export const Skeleton = () => {
    return <div className={style.container}>
        <HeaderBanner key={'bannerempty'} state={'empty'} text={'Empty'} useShape={true} />
        <TabTitles />
        <FakeImage />
        <JoinButton />
        <CompTable />
        <AdditionalInfo />
    </div>;
};
